import React, { Component } from "react";
import Column from "./Column";
import { DropZone } from "./DropZones";
const state = {
    partials: {
        partialWidth: 90,
        partialMargin: 5
    }
};
class DynamicRow extends Component {
    render() {
        return (
            <div
                style={{
                    width: "100%",
                    minHeight: 75,
                    // background: "blue",
                    zIndex: 6,
                    display: "flex",
                    alignItems: "center",
                    position: "relative"
                }}
            >
                {this.props.columnsInRow.map((col) => {
                    const { columnId, elementsInColumn, columnStyle } = col;
                    return (
                        <Column
                            key={columnId}
                            columnId={columnId}
                            elementsInColumn={elementsInColumn}
                            partials={this.props.partials}
                            columnStyle={columnStyle}
                            addGhostElementOnDragOver={
                                this.props.addGhostElementOnDragOver
                                // console.log(object);
                            }
                            removeGhostElementOnDragLeave={
                                this.props.removeGhostElementOnDragLeave
                            }
                        />
                    );
                })}
                <DropZone
                    sectionId={this.props.sectionId}
                    elDragData={this.props.elDragData}
                    addGhostElementOnDragOver={
                        () =>
                            this.props.addGhostElementOnDragOver(
                                "ON_ROW_LEFT_SIDE"
                            )
                        // console.log(object);
                    }
                    removeGhostElementOnDragLeave={() =>
                        this.props.removeGhostElementOnDragLeave(
                            "ON_ROW_LEFT_SIDE",
                            {}
                        )
                    }
                    sectionRect={this.props.sectionRect}
                    setDragZoneStatus={(status) =>
                        this.props.setDragZoneStatus("isOnRowLeftZone", status)
                    }
                    style={{
                        
                        userSelect: "none",
                        zIndex: 10,
                        width: `${state.partials.partialMargin}%`,
                        position: "absolute",
                        left: 0,
                        background: "red",
                        height: "100%"
                        // width: 20
                    }}
                />
                <DropZone
                    sectionId={this.props.sectionId}
                    elDragData={this.props.elDragData}
                    addGhostElementOnDragOver={() =>
                        this.props.addGhostElementOnDragOver(
                            "ON_ROW_MIDDLE_SIDE",
                            {}
                        )
                    }
                    removeGhostElementOnDragLeave={() =>
                        this.props.removeGhostElementOnDragLeave(
                            "ON_ROW_MIDDLE_SIDE"
                        )
                    }
                    sectionRect={this.props.sectionRect}
                    setDragZoneStatus={(status) =>
                        this.props.setDragZoneStatus(
                            "isOnRowMiddleZone",
                            status
                        )
                    }
                    style={{
                        
                        userSelect: "none",
                        zIndex: 10,
                        width: `calc(100% - ${
                            state.partials.partialMargin * 2
                        }%)`,
                        position: "absolute",
                        left: `${state.partials.partialMargin}%`,
                        background: "blue",
                        height: "100%"

                        // width: 80
                    }}
                />
                <DropZone
                    sectionId={this.props.sectionId}
                    elDragData={this.props.elDragData}
                    addGhostElementOnDragOver={() =>
                        this.props.addGhostElementOnDragOver(
                            "ON_ROW_RIGHT_SIDE",
                            {}
                        )
                    }
                    removeGhostElementOnDragLeave={() =>
                        this.props.removeGhostElementOnDragLeave(
                            "ON_ROW_RIGHT_SIDE"
                        )
                    }
                    sectionRect={this.props.sectionRect}
                    setDragZoneStatus={(status) =>
                        this.props.setDragZoneStatus("isOnRowRightZone", status)
                    }
                    style={{
                        width: `${state.partials.partialMargin}%`,
                        // width: 20,
                        userSelect: "none",
                        zIndex: 10,
                        position: "absolute",
                        left: `calc(100% - ${state.partials.partialMargin}%)`,
                        background: "green",
                        height: "100%"

                        // borderRight: "1px dashed black"
                    }}
                />
            </div>
        );
    }
}

export default DynamicRow;
